import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useListUsers } from '../../../app/ApiGen';
import { DataErrorHandler } from '../../../components/ErrorHandler';
import { TableLink } from '../../../components/Link';
import {
  Card,
  ColumnChanger,
  ColumnChangerProps,
  DataTable,
  SearchField,
  SearchFieldProps,
  Workspace,
} from '../../../design-system';
import { navigateOnRowClick } from '../../../utils/dataTable/rowHelpers';
import { getCondensedDate } from '../../../utils/dateFormat';
import { toUsersListData, UsersListData } from '../../../utils/users/list';

const UsersListView: React.FC = () => {
  const history = useHistory();
  const { url } = useRouteMatch<{ slug: string }>();
  const { data, error, loading, refetch } = useListUsers({});

  if (error) {
    return <DataErrorHandler description="Unable to load users" error={error} refetch={refetch} />;
  }

  const tableData = data?.data ? toUsersListData(data.data) : [];

  return (
    <Workspace maxWidth={false}>
      <Card>
        <DataTable<UsersListData>
          isLoading={loading}
          options={{ columnsButton: true, loadingType: 'linear' }}
          toolbarProps={{
            search: ({ dataManager, search, onSearchChanged }: SearchFieldProps) => (
              <SearchField dataManager={dataManager} item="users" onSearchChanged={onSearchChanged} search={search} />
            ),
            actions: (props: React.PropsWithChildren<ColumnChangerProps>) => (
              <ColumnChanger
                columnsButton={props.columnsButton}
                columns={props.columns}
                icons={props.icons}
                onColumnsChanged={props.onColumnsChanged}
              />
            ),
          }}
          columns={[
            {
              field: 'email',
              title: 'Email',
              defaultSort: 'asc',
              render: (rowData) => <TableLink to={`${url}/${rowData.id}`}>{rowData.email}</TableLink>,
            },
            {
              field: 'name',
              title: 'Name',
            },
            {
              field: 'created',
              title: 'Member Since',
              render: ({ updated }) => getCondensedDate(updated),
            },
            {
              field: 'updated',
              title: 'Membership Updated',
              hidden: true,
              render: ({ updated }) => getCondensedDate(updated),
            },
          ]}
          data={tableData}
          onRowClick={navigateOnRowClick((rowData) => `${url}/${rowData.id}`, history)}
        />
      </Card>
    </Workspace>
  );
};
export default UsersListView;
